import { makeStyles, Theme, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        margin: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(4)
        },
        padding: {
            padding: theme.spacing(2),
            width: 650
        },
        bulletArea: {
            background: ''
        },
        cardView: {
            flexGrow: 2,
            borderRadius: 10,
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(2),
            fontSize: '1.1em',
            letterSpacing: 1,
        },
        cardContent: {
            font: 'Arial, Arial Bold',
            wordWrap: 'normal',
            fontWeight: 'normal'
        },
        taskTypeCaption: {
            font: 'Arial, Arial Bold',
            fontWeight: 'bold'
        },
        reportProblem: {
            fontSize: '3em',
            marginTop: 20,
            marginLeft: 20
        },
        doneAll: {
            //fontSize: '6em',
            width: '150%',
            height: '150%',
            transform: 'translateX(-10px)'
        },
        xRay: {
            width: '200%',
            height: '200%',
            //fontSize: '5em',
            // marginTop: 15,
            // marginLeft: 15
        },
        rightCol: {
            //maxWidth: 450
        },


    }),
);